var map = {
	"./csc_05.png": "f2be",
	"./logo_2021_554d3ee.png": "05d9",
	"./toplogo.png": "d7bf",
	"./下载 (1).png": "c0d7",
	"./下载.png": "ef33",
	"./图片 1.png": "483e",
	"./图片 11.png": "dabc",
	"./图片 51.png": "e723"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7338";